import { AutocompleteType } from '@shared/base-search-bar/entities/search-input-payload';

export const AutocompleteVisibilityMax = 4;

export const AutocompleteDefaultVisibility = {
  [AutocompleteType.Cities]: { Count: AutocompleteVisibilityMax, ShowAll: false },
  [AutocompleteType.Airports]: { Count: AutocompleteVisibilityMax, ShowAll: false },
  [AutocompleteType.Activities]: { Count: AutocompleteVisibilityMax, ShowAll: false },
  [AutocompleteType.Destinations]: { Count: AutocompleteVisibilityMax, ShowAll: false },
};
